/**
 * @generated SignedSource<<34d71cb953e138a0f55a9caaf5246a35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useExposedReturnsClientVariant_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useEuEligible_viewer">;
  readonly " $fragmentType": "useExposedReturnsClientVariant_viewer";
};
export type useExposedReturnsClientVariant_viewer$key = {
  readonly " $data"?: useExposedReturnsClientVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useExposedReturnsClientVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useExposedReturnsClientVariant_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useEuEligible_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bc28547ed49e1f4b9b5ab15503429dcc";

export default node;
